const langObj = {
  af: 'Afrikaans',
  'af-ZA': 'Afrikaans (South Africa)',
  ar: 'Arabic',
  'ar-AE': 'Arabic (U.A.E.)',
  'ar-BH': 'Arabic (Bahrain)',
  'ar-DZ': 'Arabic (Algeria)',
  'ar-EG': 'Arabic (Egypt)',
  'ar-IQ': 'Arabic (Iraq)',
  'ar-JO': 'Arabic (Jordan)',
  'ar-KW': 'Arabic (Kuwait)',
  'ar-LB': 'Arabic (Lebanon)',
  'ar-LY': 'Arabic (Libya)',
  'ar-MA': 'Arabic (Morocco)',
  'ar-OM': 'Arabic (Oman)',
  'ar-QA': 'Arabic (Qatar)',
  'ar-SA': 'Arabic (Saudi Arabia)',
  'ar-SY': 'Arabic (Syria)',
  'ar-TN': 'Arabic (Tunisia)',
  'ar-YE': 'Arabic (Yemen)',
  az: 'Azeri (Latin)',
  'az-AZ': 'Azeri (Cyrillic) (Azerbaijan)',
  be: 'Belarusian',
  'be-BY': 'Belarusian (Belarus)',
  bg: 'Bulgarian',
  'bg-BG': 'Bulgarian (Bulgaria)',
  'bs-BA': 'Bosnian (Bosnia and Herzegovina)',
  ca: 'Catalan',
  'ca-ES': 'Catalan (Spain)',
  cs: 'Czech',
  'cs-CZ': 'Czech (Czech Republic)',
  cy: 'Welsh',
  'cy-GB': 'Welsh (United Kingdom)',
  da: 'Danish',
  'da-DK': 'Danish (Denmark)',
  de: 'German',
  'de-AT': 'German (Austria)',
  'de-CH': 'German (Switzerland)',
  'de-DE': 'German (Germany)',
  'de-LI': 'German (Liechtenstein)',
  'de-LU': 'German (Luxembourg)',
  dv: 'Divehi',
  'dv-MV': 'Divehi (Maldives)',
  el: 'Greek',
  'el-GR': 'Greek (Greece)',
  en: 'English',
  'en-AU': 'English (Australia)',
  'en-BZ': 'English (Belize)',
  'en-CA': 'English (Canada)',
  'en-CB': 'English (Caribbean)',
  'en-GB': 'English (United Kingdom)',
  'en-IE': 'English (Ireland)',
  'en-JM': 'English (Jamaica)',
  'en-NZ': 'English (New Zealand)',
  'en-PH': 'English (Republic of the Philippines)',
  'en-TT': 'English (Trinidad and Tobago)',
  'en-US': 'English (United States)',
  'en-ZA': 'English (South Africa)',
  'en-ZW': 'English (Zimbabwe)',
  eo: 'Esperanto',
  es: 'Spanish',
  'es-AR': 'Spanish (Argentina)',
  'es-BO': 'Spanish (Bolivia)',
  'es-CL': 'Spanish (Chile)',
  'es-CO': 'Spanish (Colombia)',
  'es-CR': 'Spanish (Costa Rica)',
  'es-DO': 'Spanish (Dominican Republic)',
  'es-EC': 'Spanish (Ecuador)',
  'es-ES': 'Spanish (Spain)',
  'es-GT': 'Spanish (Guatemala)',
  'es-HN': 'Spanish (Honduras)',
  'es-MX': 'Spanish (Mexico)',
  'es-NI': 'Spanish (Nicaragua)',
  'es-PA': 'Spanish (Panama)',
  'es-PE': 'Spanish (Peru)',
  'es-PR': 'Spanish (Puerto Rico)',
  'es-PY': 'Spanish (Paraguay)',
  'es-SV': 'Spanish (El Salvador)',
  'es-UY': 'Spanish (Uruguay)',
  'es-VE': 'Spanish (Venezuela)',
  et: 'Estonian',
  'et-EE': 'Estonian (Estonia)',
  eu: 'Basque',
  'eu-ES': 'Basque (Spain)',
  fa: 'Farsi',
  'fa-IR': 'Farsi (Iran)',
  fi: 'Finnish',
  'fi-FI': 'Finnish (Finland)',
  fo: 'Faroese',
  'fo-FO': 'Faroese (Faroe Islands)',
  fr: 'French',
  'fr-BE': 'French (Belgium)',
  'fr-CA': 'French (Canada)',
  'fr-CH': 'French (Switzerland)',
  'fr-FR': 'French (France)',
  'fr-LU': 'French (Luxembourg)',
  'fr-MC': 'French (Principality of Monaco)',
  gl: 'Galician',
  'gl-ES': 'Galician (Spain)',
  gu: 'Gujarati',
  'gu-IN': 'Gujarati (India)',
  he: 'Hebrew',
  'he-IL': 'Hebrew (Israel)',
  hi: 'Hindi',
  'hi-IN': 'Hindi (India)',
  hr: 'Croatian',
  'hr-BA': 'Croatian (Bosnia and Herzegovina)',
  'hr-HR': 'Croatian (Croatia)',
  hu: 'Hungarian',
  'hu-HU': 'Hungarian (Hungary)',
  hy: 'Armenian',
  'hy-AM': 'Armenian (Armenia)',
  id: 'Indonesian',
  'id-ID': 'Indonesian (Indonesia)',
  is: 'Icelandic',
  'is-IS': 'Icelandic (Iceland)',
  it: 'Italian',
  'it-CH': 'Italian (Switzerland)',
  'it-IT': 'Italian (Italy)',
  ja: 'Japanese',
  'ja-JP': 'Japanese (Japan)',
  ka: 'Georgian',
  'ka-GE': 'Georgian (Georgia)',
  kk: 'Kazakh',
  'kk-KZ': 'Kazakh (Kazakhstan)',
  kn: 'Kannada',
  'kn-IN': 'Kannada (India)',
  ko: 'Korean',
  'ko-KR': 'Korean (Korea)',
  kok: 'Konkani',
  'kok-IN': 'Konkani (India)',
  ky: 'Kyrgyz',
  'ky-KG': 'Kyrgyz (Kyrgyzstan)',
  lt: 'Lithuanian',
  'lt-LT': 'Lithuanian (Lithuania)',
  lv: 'Latvian',
  'lv-LV': 'Latvian (Latvia)',
  mi: 'Maori',
  'mi-NZ': 'Maori (New Zealand)',
  mk: 'FYRO Macedonian',
  'mk-MK': 'FYRO Macedonian (Former Yugoslav Republic of Macedonia)',
  mn: 'Mongolian',
  'mn-MN': 'Mongolian (Mongolia)',
  mr: 'Marathi',
  'mr-IN': 'Marathi (India)',
  ms: 'Malay',
  'ms-BN': 'Malay (Brunei Darussalam)',
  'ms-MY': 'Malay (Malaysia)',
  mt: 'Maltese',
  'mt-MT': 'Maltese (Malta)',
  nb: 'Norwegian (Bokm?l)',
  'nb-NO': 'Norwegian (Bokm?l) (Norway)',
  nl: 'Dutch',
  'nl-BE': 'Dutch (Belgium)',
  'nl-NL': 'Dutch (Netherlands)',
  'nn-NO': 'Norwegian (Nynorsk) (Norway)',
  ns: 'Northern Sotho',
  'ns-ZA': 'Northern Sotho (South Africa)',
  pa: 'Punjabi',
  'pa-IN': 'Punjabi (India)',
  pl: 'Polish',
  'pl-PL': 'Polish (Poland)',
  ps: 'Pashto',
  'ps-AR': 'Pashto (Afghanistan)',
  pt: 'Portuguese',
  'pt-BR': 'Portuguese (Brazil)',
  'pt-PT': 'Portuguese (Portugal)',
  qu: 'Quechua',
  'qu-BO': 'Quechua (Bolivia)',
  'qu-EC': 'Quechua (Ecuador)',
  'qu-PE': 'Quechua (Peru)',
  ro: 'Romanian',
  'ro-RO': 'Romanian (Romania)',
  ru: 'Russian',
  'ru-RU': 'Russian (Russia)',
  sa: 'Sanskrit',
  'sa-IN': 'Sanskrit (India)',
  se: 'Sami (Northern)',
  'se-FI': 'Sami (Inari) (Finland)',
  'se-NO': 'Sami (Southern) (Norway)',
  'se-SE': 'Sami (Southern) (Sweden)',
  sk: 'Slovak',
  'sk-SK': 'Slovak (Slovakia)',
  sl: 'Slovenian',
  'sl-SI': 'Slovenian (Slovenia)',
  sq: 'Albanian',
  'sq-AL': 'Albanian (Albania)',
  'sr-BA': 'Serbian (Cyrillic) (Bosnia and Herzegovina)',
  'sr-SP': 'Serbian (Cyrillic) (Serbia and Montenegro)',
  sv: 'Swedish',
  'sv-FI': 'Swedish (Finland)',
  'sv-SE': 'Swedish (Sweden)',
  sw: 'Swahili',
  'sw-KE': 'Swahili (Kenya)',
  syr: 'Syriac',
  'syr-SY': 'Syriac (Syria)',
  ta: 'Tamil',
  'ta-IN': 'Tamil (India)',
  te: 'Telugu',
  'te-IN': 'Telugu (India)',
  th: 'Thai',
  'th-TH': 'Thai (Thailand)',
  tl: 'Tagalog',
  'tl-PH': 'Tagalog (Philippines)',
  tn: 'Tswana',
  'tn-ZA': 'Tswana (South Africa)',
  tr: 'Turkish',
  'tr-TR': 'Turkish (Turkey)',
  tt: 'Tatar',
  'tt-RU': 'Tatar (Russia)',
  ts: 'Tsonga',
  uk: 'Ukrainian',
  'uk-UA': 'Ukrainian (Ukraine)',
  ur: 'Urdu',
  'ur-PK': 'Urdu (Islamic Republic of Pakistan)',
  uz: 'Uzbek (Latin)',
  'uz-UZ': 'Uzbek (Cyrillic) (Uzbekistan)',
  vi: 'Vietnamese',
  'vi-VN': 'Vietnamese (Viet Nam)',
  xh: 'Xhosa',
  'xh-ZA': 'Xhosa (South Africa)',
  zh: 'Chinese',
  'zh-CN': 'Chinese (S)',
  'zh-HK': 'Chinese (Hong Kong)',
  'zh-MO': 'Chinese (Macau)',
  'zh-SG': 'Chinese (Singapore)',
  'zh-TW': 'Chinese (T)',
  zu: 'Zulu',
  'zu-ZA': 'Zulu (South Africa)',
};

// 新增：常用语言配置（用于界面语言选择）
export const COMMON_LANGUAGES = [
  'en', // English
  'zh', // Chinese
];

// 新增：原生语言名称映射（用于显示本地化名称）
export const NATIVE_LANGUAGE_NAMES = {
  en: 'English',
  zh: '中文',
};

// 新增：获取语言信息的安全函数
export const getLanguageInfo = (code) => {
  const baseCode = code.split('-')[0]; // 获取基础语言代码
  const englishName = langObj[code] || langObj[baseCode] || 'Unknown';
  const nativeName = NATIVE_LANGUAGE_NAMES[code] || NATIVE_LANGUAGE_NAMES[baseCode] || englishName;

  return {
    code,
    name: englishName,
    local: nativeName,
    nativeName: nativeName,
    isCommon: COMMON_LANGUAGES.includes(baseCode)
  };
};

// 改进语言选项获取函数
export const getCommonLanguageOptions = () => {
  return [
    {
      value: 'en',
      label: 'English',
      localName: 'English',
      flag: '🇺🇸'
    },
    {
      value: 'zh',
      label: 'Chinese',
      localName: '中文',
      flag: '🇨🇳'
    }
  ];
};

// 改进语言映射
export const LANGUAGE_MAP = {
  en: { name: 'English', local: 'English' },
  zh: { name: 'Chinese', local: '中文' }
};

// 新增：获取所有可用语言选项
export const getAllLanguageOptions = () => {
  const allCodes = Object.keys(langObj);
  return allCodes.map(code => {
    const info = getLanguageInfo(code);
    return {
      value: code,
      label: info.name,
      localName: info.local,
      nativeName: info.nativeName,
      isCommon: info.isCommon
    };
  }).sort((a, b) => a.label.localeCompare(b.label));
};

// 改进语言检测函数
export const detectBrowserLanguage = () => {
  try {
    // 获取浏览器语言列表
    const browserLanguages = [
      navigator.language,
      ...(navigator.languages || []),
      navigator.userLanguage, // IE
      navigator.systemLanguage, // IE
    ].filter(Boolean);

    console.log('Browser languages detected:', browserLanguages);

    // 支持的语言列表
    const supportedLanguages = ['en', 'zh'];

    // 语言映射规则
    const languageMapping = {
      'en': 'en',
      'en-US': 'en',
      'en-GB': 'en',
      'zh': 'zh',
      'zh-CN': 'zh',
      'zh-TW': 'zh',
      'zh-HK': 'zh',
    };

    // 遍历浏览器语言列表
    for (const browserLang of browserLanguages) {
      if (!browserLang) continue;

      // 完全匹配
      if (languageMapping[browserLang]) {
        console.log(`Language matched: ${browserLang} -> ${languageMapping[browserLang]}`);
        return languageMapping[browserLang];
      }

      // 部分匹配（只匹配语言代码部分）
      const langCode = browserLang.split('-')[0];
      if (supportedLanguages.includes(langCode)) {
        console.log(`Language code matched: ${browserLang} -> ${langCode}`);
        return langCode;
      }
    }

    console.log('No matching language found, falling back to English');
    return 'en'; // 默认返回英语
  } catch (error) {
    console.error('Error detecting browser language:', error);
    return 'en';
  }
};

// 新增：格式化语言显示
export const formatLanguageDisplay = (code, showLocal = true) => {
  const info = getLanguageInfo(code);
  if (showLocal && info.local !== info.name) {
    return `${info.name} (${info.local})`;
  }
  return info.name;
};

// 新增：多语言文本配置
export const MULTILINGUAL_TEXTS = {
  en: {
    // 筛选相关
    timeRange: 'Time Range:',
    game: 'Game:',
    allGames: 'All Games',
    sort: 'Sort:',
    search: 'Search:',
    searchPlaceholder: 'Search username or Twitch username...',
    more: 'More',
    gameTags: 'Game Tags',
    gameType: 'Game Type:',
    gameTheme: 'Game Theme:',
    addType: 'Add Type',
    addTheme: 'Add Theme',

    // 用户列表相关
    userList: 'User List ({{count}} users)',
    selectedUsers: '- Selected {{count}} users',
    oneClickSelect: 'One-Click Select',
    addToPackage: 'Add to Streamer Package',
    clearSelection: 'Clear Selection',

    // 排序选项
    matchScore: 'Match Score',
    activityLevel: 'Activity Level',
    executionAbility: 'Execution Ability',
    costEffectiveness: 'Cost Effectiveness',
    followers: 'Followers',
    avgViewers: 'Average Viewers',

    // 主播类型
    unlimited: 'Unlimited',
    premiumStreamer: 'Premium',
    potentialStreamer: 'Potential',
    normalStreamer: 'Normal',
    otherStreamers: 'Other',

    // 评价标签
    activity: 'Activity',
    execution: 'Execution',
    costEffect: 'Cost-Effect',
    noRating: 'No Rating',

    // 消息
    loadingUsers: 'Loading user data...',
    noUsers: 'No matching users found',
    addedToSelection: 'Added {{count}} users from current page to selection list',
    clearedSelection: 'Cleared selection of {{count}} users',

    // 语言相关
    languageSettings: 'Language Settings',
    interfaceLanguage: 'Interface Language',
    contentLanguage: 'Content Language',
    autoDetect: 'Auto Detect',

    // 添加缺失的翻译
    language: 'Language',
    streamerFilterSystem: 'Streamer Filter System',
    streamerGroupManagement: 'Streamer Group Management',
    streamerPackageSystem: 'Streamer Package Management System',
    groupList: 'Group List',
    addGroup: 'Add Group',
    loadingGroups: 'Loading groups...',
    noGroups: 'No groups available',
    memberCount: '{{count}} members',
    edit: 'Edit',
    delete: 'Delete',
    days: 'days',
    tags: 'tags',
    noTags: 'No Tags',
    search: 'Search',
    rowsPerPage: 'Rows per page:',
    displayedRows: '{{from}}-{{to}} of {{count}}',
    close: 'Close',
    current: 'Current',

    // 添加 StreamerGroupManager 需要的翻译
    totalGames: 'Total Games',
    totalGroups: 'Total Groups',
    totalPackages: 'Total Packages',
    totalStreamers: 'Total Streamers',
    existingGroups: 'Existing Groups ({{count}} groups)',
    streamers: 'Streamers',
    packages: 'Packages',
    viewExpectedData: 'View Expected Data',
    sendTaskInvitation: 'Send Task Invitation',
    viewDays: 'View Days:',
    switchingToPackage: 'Switching to "{{name}}"...',
    loadingStreamerData: 'Loading streamer data...',
    streamerList: 'Streamer List ({{count}} streamers)',
    selected: 'Selected {{count}}',
    oneClickSelect: 'One-Click Select',
    transferToOtherPackage: 'Transfer to Other Package ({{count}})',
    deleteSelected: 'Delete Selected ({{count}})',
    clearSelection: 'Clear Selection',
    selectedStreamers: 'Selected streamers:',
    noOtherPackagesAvailable: '⚠️ No other packages available in current group, cannot transfer',
    noStreamers: 'No Streamers',
    noStreamersInPackage: 'This package currently has no streamers',
    pleaseSelectGroupAndPackage: 'Please select a group and package',
    selectGroupAndPackageToView: 'Select a group and package from the left to view streamer list',
    packageNotExists: 'Package does not exist',
    currentSelectedPackageInvalid: 'Current selected package index is invalid',
    searchGroups: 'Search groups...',
    groupManagementHome: 'Group Management Home',
    refreshing: 'Refreshing...',
    noMatchingGroups: 'No matching groups found',
    noGroupData: 'No group data available',
    createPackage: 'Create Package',
    editPackage: 'Edit Package',
    deletePackage: 'Delete Package',
    confirmDeletePackage: 'Confirm Delete Package',
    confirmDeletePackageMessage: 'Are you sure you want to delete package "{{name}}"?',
    cannotUndoOperation: '⚠️ This operation cannot be undone, all streamer data in the package will be cleared',
    deleting: 'Deleting...',
    confirmDelete: 'Confirm Delete',
    autoGenerateDefaultGroups: 'Auto Generate Default Groups',
    packageBasicInfo: 'Basic Information',
    packageName: 'Package Name',
    enterPackageName: 'Please enter package name...',
    packageDescription: 'Package Description',
    enterPackageDescription: 'Please enter package description...',
    packageSettings: 'Package Settings',
    maxStreamers: 'Max Streamers',
    priority: 'Priority',
    higherNumberHigherPriority: 'Higher number = higher priority',
    visibilityLevel: 'Visibility Level',
    tags: 'Tags',
    enterTagsCommaSeparated: 'Enter tags, separated by commas',
    tagsExample: 'e.g.: Premium, Popular, Beginner',
    streamerManagement: 'Streamer Management',
    currentlySelected: 'Currently selected {{count}} streamers',
    streamerListAutoGenerated: '* Streamer list will be auto-generated based on package settings and filter criteria',
    packageStats: 'Package Statistics:',
    actualStreamers: 'Actual Streamers: {{count}}',
    averageViewers: 'Average Viewers: {{count}}',
    totalFollowers: 'Total Followers: {{count}}',
    calculationPeriod: 'Calculation Period: {{period}}',
    processing: 'Processing...',
    create: 'Create',
    update: 'Update',
    public: 'Public',
    private: 'Private',
    restricted: 'Restricted',
    transferUsersToOtherPackage: 'Transfer Users to Other Package',
    transferInfo: 'Transfer Information',
    gameGroup: 'Game Group:',
    currentPackage: 'Current Package:',
    selectedUsersCount: 'Selected Users:',
    selectTargetPackage: 'Select Target Package',
    transferInstructions: 'Transfer Instructions:',
    transferInstruction1: '• Users will be removed from current package and added to target package',
    transferInstruction2: '• Transfer operation cannot be undone, please confirm correct target package',
    transferInstruction3: '• Data will be automatically refreshed after transfer completion',
    confirmTransfer: 'Confirm Transfer',
    transferring: 'Transferring...',
    noActiveQuests: 'No Active Quests',
    noActiveQuestsForGame: 'Current game has no available active quests',
    loadingActiveQuests: 'Loading active quests...',
    sendTaskInvitationTo: 'Send task invitation to {{count}} streamers:',
    selectTasksToSend: 'Select tasks to send',
    totalTasks: 'Total {{total}} tasks, selected {{selected}}',
    selectAllTasks: 'Select All Tasks',
    deselectAllTasks: 'Deselect All',
    taskOverview: 'Task Overview',
    totalTasksCount: 'Total Tasks',
    selectedTasks: 'Selected',
    streamingTasks: 'Streaming Tasks',
    creationTasks: 'Creation Tasks',
    urgentTasks: 'Urgent Tasks',
    startTime: 'Start Time',
    endTime: 'End Time',
    taskType: 'Task Type',
    requiredStreamTime: 'Required Stream Time',
    notSet: 'Not Set',
    noRequirement: 'No Requirement',
    streamingTask: 'Streaming Task',
    creationTask: 'Creation Task',
    contentCreation: 'Content Creation',
    promotionTask: 'Promotion Task',
    eventTask: 'Event Task',
    unknownType: 'Unknown Type',
    urgent: 'Urgent',
    minimumViewers: 'Minimum Viewers: {{count}}',
    rewards: 'Rewards:',
    sendPreview: 'Send Preview:',
    willSendInvitationEmail: 'Will send invitation email containing {{taskCount}} tasks to {{userCount}} streamers',
    selectedTasksList: 'Selected tasks:',
    sendInvitation: 'Send Invitation ({{count}} streamers)',
    sending: 'Sending...',
    minutes: 'minutes',
    hours: 'hours',
    days: 'days',
    unknownUser: 'Unknown User',
    expectedDataStats: 'Expected Data Statistics',
    statsOverview: 'Statistics Overview',
    group: 'Group:',
    package: 'Package:',
    statsPeriod: 'Statistics Period:',
    calculationTime: 'Calculation Time:',
    streamersCount: 'Streamers',
    averageCCV: 'Average CCV',
    peakCCV: 'Peak CCV',
    totalFollowersCount: 'Total Followers',
    detailedStats: 'Detailed Statistics',
    streamingTimeStats: 'Streaming Time Statistics',
    totalStreamingTime: 'Total Streaming Time:',
    avgStreamingTimePerStreamer: 'Avg Streaming Time per Streamer:',
    viewingDataStats: 'Viewing Data Statistics',
    totalViewingTime: 'Total Viewing Time:',
    vodViews: 'VOD Views:',
    dataExplanation: 'Data Explanation:',
    dataNote1: '• Above data is calculated and predicted based on selected streamers\' performance in the past {{days}} days',
    dataNote2: '• Average CCV is calculated based on streamers\' ACCV data',
    dataNote3: '• Peak CCV, viewing time and other metrics are predicted based on historical data and algorithm models',
    dataNote4: '• Actual data may vary due to streamer performance, game popularity and other factors',
    calculatingExpectedData: 'Calculating expected data...',
    basedOnRecentDaysData: 'Based on streamer data from the past {{days}} days for analysis',
    dataCalculationFailed: 'Data calculation failed',
    retryOrContactSupport: 'Please retry or contact technical support',
    refreshData: 'Refresh Data',
    // 新增翻译
    autoGenerateComplete: 'Auto generation completed: Created {{groups}} groups and {{packages}} packages',
    noNewGroupsOrPackages: 'No new groups or packages need to be created',
    autoGenerationFailed: 'Auto generation failed: {{error}}',
    processingAutoGeneration: 'Processing auto generation...',
    thisOperationWillCreate: 'This operation will automatically create default groups and packages for all eligible games.',
    onlyCreateForGamesWithoutDefault: '• Only create new groups for games without default groups',
    onlyCreateForGroupsWithoutDefault: '• Only create new packages for groups without default packages',
    onlyProcessActiveGamesWithTwitch: '• Only process games with status "active" and nameInTwitch',
    operationCannotBeUndone: '⚠️ This operation cannot be undone, please proceed with caution',
    generating: 'Generating...',
    autoGeneratingGroupsAndPackages: 'Auto generating groups and packages...',
    thisCouldTakeMinutes: 'Please wait, this may take several minutes',
    generationResults: 'Generation Results',
    processedGames: 'Processed Games:',
    createdGroups: 'Created Groups:',
    createdPackages: 'Created Packages:',
    successfullyProcessed: 'Successfully Processed:',
    failedProcessed: 'Failed Processed:',
    successRate: 'Success Rate: {{rate}}',
    operator: 'Operator: {{username}}',
    startGeneration: 'Start Generation',
    completed: 'Completed',
    //----------- 主播包补充翻译的-------------

    // 时间范围
    '30days': '30 Days',
    '60days': '60 Days',
    '90days': '90 Days',
    '120days': '120 Days',
    '365days': '365 Days',
    'days': 'Days',

    // 筛选相关
    timeRange: 'Time Range:',
    game: 'Game:',
    allGames: 'All Games',
    sort: 'Sort:',
    search: 'Search:',
    searchPlaceholder: 'Search username or Twitch username...',
    more: 'More',
    gameTags: 'Game Tags',
    gameType: 'Game Type:',
    gameTheme: 'Game Theme:',
    addType: 'Add Type',
    addTheme: 'Add Theme',

    // 排序选项
    matchScore: 'Match Score',
    activityLevel: 'Activity Level',
    executionAbility: 'Execution Ability',
    costEffectiveness: 'Cost Effectiveness',
    followers: 'Followers',
    avgViewers: 'Average Viewers',

    // 主播类型
    streamerType: 'Streamer Type:',
    // unlimited: 'Unlimited',
    // premiumStreamer: 'Premium Streamer',
    // potentialStreamer: 'Potential Streamer',
    // normalStreamer: 'Normal Streamer',
    // otherStreamers: 'Other Streamers',

    // 卡片内容
    followersLabel: 'Followers',
    activity: 'Activity',
    execution: 'Execution',
    costEffect: 'Cost-Effect',
    matchDegree: 'Match',
    noRating: 'No Rating',

    // 搜索按钮
    searchBtn: 'Search',

    // More 菜单项
    syncStreamerRatings: 'Sync Streamer Ratings',
    syncGameTags: 'Sync Game Tags',
    syncGameInfo: 'Sync Game Info',

    // 弹窗内容 - 主播评价体系管理
    streamerRatingSystemManagement: 'Streamer Rating System Management',
    syncTags: 'Sync Tags',
    systemConfig: 'System Configuration',
    syncStreamerRatingTags: 'Sync Streamer Rating Tags',
    syncAllStreamerRatingDesc: 'Sync all streamers\' rating tag data, including activity level, completion ability and cost effectiveness indicators.',
    currentConfigOverview: 'Current Configuration Overview',
    tagTypesCount: 'Tag Types Total',
    activeTagsCount: 'Active Tags',
    totalTagsCount: 'Total Tags',
    tagTypesOverview: 'Tag Types Overview',
    noConfigData: 'No configuration data',
    syncOptionSettings: 'Sync Option Settings',
    forceUpdateAllUsers: 'Force Update All Users',
    forceUpdateDesc: 'When checked, will force update all streamers\' rating tags, including users with existing ratings. When unchecked, will skip users with existing ratings and only update new users or users with missing ratings.',
    startSyncTags: 'Start Sync Tags',
    viewDetailedConfig: 'View Detailed Configuration',
    forceUpdateMode: 'Force update mode: Will recalculate all streamers\' rating tags, this process may take a long time.',
    smartUpdateMode: 'Smart update mode: Only update new users or users with missing ratings, can save time.',
    tagTypeConfig: 'Tag Type Configuration',
    cancel: 'Cancel',
    save: 'Save',
    saving: 'Saving...',
    saveTypeConfig: 'Save Type Configuration',
    editTypeConfig: 'Edit Type Configuration',
    typeCode: 'Type Code',
    typeName: 'Type Name',
    defaultStatDays: 'Default Stat Days',
    description: 'Description',
    noTagTypeData: 'No tag type data',
    tagDetailedConfig: 'Tag Detailed Configuration',
    saveTagConfig: 'Save Tag Configuration',
    editTagConfig: 'Edit Tag Configuration',
    initializeSystem: 'Initialize System',
    initializing: 'Initializing...',
    tagCode: 'Tag Code',
    tagName: 'Tag Name',
    category: 'Category',
    registrationTime: 'Registration Time',
    recentApplicationDays: 'Recent Application Days',
    applicationRatio: 'Application Ratio',
    recentCompletionDays: 'Recent Completion Days',
    completionRatio: 'Completion Ratio',
    completionRateRatio: 'Completion Rate Ratio',
    rewardRatio: 'Reward Ratio',
    priority: 'Priority',
    status: 'Status',
    enabled: 'Enabled',
    disabled: 'Disabled',
    noTagConfigData: 'No tag configuration data',
    editInstructions: 'Edit Instructions:',
    editInstructionsDesc: '• Tag type configuration: Can edit default stat days and description\n• Tag detailed configuration: Can edit tag name and registration time range\n• 110-150 tags: Can edit application ratio range\n• 210-250 tags: Can edit completion ratio and completion rate ratio range\n• 310-350 tags: Can edit completion rate ratio and reward ratio range',

    // 弹窗内容 - 游戏标签同步
    syncGameTagsTitle: 'Sync Game Tags',
    selectGameTagTimeRange: 'Select the game tag time range to sync, the system will recalculate user game preference tags for the selected time ranges.',
    updateAllTimeRanges: 'Update All Time Ranges',
    updateAllTimeRangesDesc: 'When checked, all time ranges (30, 60, 90, 120, 365 days) tags will be updated, ignoring the specific selections below.',
    selectGameTagRanges: 'Select Game Tag Ranges (Multiple Selection):',
    allRangesSelected: 'All ranges selected for update, selections below will be ignored',
    pleaseSelectAtLeastOne: 'Please select at least one time range',
    willUpdateAllRanges: 'Will update all time ranges (30, 60, 90, 120, 365 days) tags',
    selectedRanges: 'Selected {{count}} time ranges: {{ranges}} days',
    syncLatestData: 'Sync Latest Data',
    syncLatestDataDesc: 'If checked, will fetch latest game data from data source before recalculating tags. If unchecked, will only recalculate tags based on existing data without updating game data.',
    syncProcessDesc: 'Sync process may take several minutes, depending on user count and selected ranges.',
    updateAllRangesTakeLonger: 'Updating all ranges may take longer time.',
    startSync: 'Start Sync',
    syncing: 'Syncing...',

    // 弹窗内容 - 游戏信息同步
    gameIGDBInfoSync: 'Game IGDB Info Sync',
    syncConfig: 'Sync Configuration',
    selectGameSource: 'Select Game Source',
    allGames: 'All Games',
    noizPlatformGames: 'Noiz Platform Games',
    nonNoizPlatformGames: 'Non-Noiz Platform Games',
    allGamesDesc: 'Get all game data from UserGame table',
    noizGamesDesc: 'Get platform certified games from Game table',
    nonNoizGamesDesc: 'Other games excluding platform games',
    statDays: 'Stat Days',
    syncMode: 'Sync Mode',
    smartSync: 'Smart Sync (Unsynced Only)',
    forceSync: 'Force Sync (Synced Only)',
    fullSync: 'Full Sync (All Games)',
    searchGames: 'Search Games...',
    searchGame: 'Search Games',
    statsOverview: 'Statistics Overview',
    loadingData: 'Loading data...',
    totalGamesCount: 'Total Games',
    synced: 'Synced',
    unsynced: 'Unsynced',
    syncRate: 'Sync Rate',
    gameList: 'Game List',
    selectAll: 'Select All',
    deselectAll: 'Deselect All',
    selectedCount: 'Selected {{count}}',
    gameListEmpty: 'No matching games found',
    loadingGameData: 'Loading game data...',
    noGameData: 'No games found',
    operationInstructions: 'Operation Instructions',
    operationInstructionsDesc: '• Select games and click "Start Sync", if none selected will sync all matching games\n• Smart sync: Skip games with existing IGDB info\n• Force sync: Re-fetch games with existing IGDB info\n• Full sync: Process all games, decide whether to overwrite based on existing status',
    syncInProgress: 'Syncing...',
    syncIGDBInfo: 'Sync IGDB Info',
    currentProcessing: 'Current: {{game}}',
    progress: 'Progress: {{processed}}/{{total}}',

    // 用户列表相关
    userList: 'User List ({{count}} users)',
    selectedUsers: '- Selected {{count}} users',
    oneClickSelect: 'One-Click Select',
    addToPackage: 'Add to Streamer Package',
    clearSelection: 'Clear Selection',

    // 消息
    loadingUsers: 'Loading user data...',
    noUsers: 'No matching users found',
    addedToSelection: 'Added {{count}} users from current page to selection list',
    clearedSelection: 'Cleared selection of {{count}} users',

    // 语言相关
    languageSettings: 'Language Settings',
    interfaceLanguage: 'Interface Language',
    contentLanguage: 'Content Language',
    autoDetect: 'Auto Detect',

    // 只添加真正缺失的翻译
    addToStreamerPackage: 'Add to Streamer Package',
    selectedUsersCount: 'Selected {{count}} users',
    selectedUsersList: 'Selected users list:',
    typeDistribution: 'Type distribution:',
    selectionPersistence: 'Selection persistence: User selections will persist when paginating or filtering, you can manually click tag delete icon to remove individual users',
    clickToAddToPackage: 'Click "Add to Streamer Package" to batch add selected users to specified game streamer package',

    currentFilters: 'Current Filters',
    clearAllFilters: 'Clear All Filters',
    filterPersistence: 'Filter results will persist across pages',

    match: 'Match',
    viewStats: 'View Stats',

    // 主播包弹窗相关
    addUsersToStreamerPackage: 'Add Users to Streamer Package',
    aboutToAdd: 'About to add {{count}} users to streamer package:',
    searchAndSelectGameGroup: '1. Search and select game group',
    enterGameNameToSearch: 'Enter game name to search...',
    selectedGame: 'Selected game:',
    defaultGroup: 'Default Group: {{groupName}}',
    autoSelectedDefaultGroup: 'Auto-selected default group, found {{count}} available streamer packages',
    selectStreamerPackage: '2. Select streamer package',
    pleaseSelectGameFirst: 'Please select game first',
    gameHasNoDefaultGroup: 'This game has no default group',
    selectStreamerPackageOption: 'Select streamer package',
    noAvailablePackages: 'This group has no available streamer packages currently',
    addPreview: 'Add Preview:',
    willAddUsersToPackage: 'Will add {{userCount}} users to "{{packageName}}" package',
    packageCurrently: 'Package currently has {{current}} streamers, will have {{total}} after adding (limit: {{max}})',
    operationDescription: 'Operation description: Select game and then auto-select the default group for that game, then you can choose packages under the group',
    adding: 'Adding...',
    addUsers: 'Add {{count}} Users',

    // IGDB同步进度相关
    syncingIGDBInfo: 'Syncing IGDB info...',
    currentProcessing: 'Current processing: {{game}}',

    // 用户相关
    noRatingData: 'No rating data',
    unknownUser: 'Unknown User',

    // 数据相关
    gameCount: '{{count}} games',
    tagCount: '{{count}} tags',
    userCount: '{{count}} users',
    items: 'items',
    // 其他的翻译
    // 数据加载页面
    loadingStreamerGroupData: 'Loading streamer group data...',
    loadingLatestGroupInfo: 'Please wait, loading latest group and streamer information',

    // 左侧栏
    streamers: 'streamers',
    streamer: 'streamer',
    streamersCount: '{{count}} streamers',
    streamerCount: '{{count}} streamer',

    // 自动生成相关
    autoGenerateDefaultGroups: 'Auto Generate Default Groups',
    autoGenerateDefaultGroupsAndPackages: 'Auto Generate Default Groups and Packages',
    thisOperationWillCreate: 'This operation will automatically create default groups and packages for all eligible games.',
    onlyCreateForGamesWithoutDefault: '• Only create new groups for games without default groups',
    onlyCreateForGroupsWithoutDefault: '• Only create new packages for groups without default packages',
    onlyProcessActiveGamesWithTwitch: '• Only process games with status "active" and nameInTwitch',
    operationCannotBeUndone: '⚠️ This operation cannot be undone, please proceed with caution',
    cancel: 'Cancel',
    startGeneration: 'Start Generation',
    generating: 'Generating...',
    autoGeneratingGroupsAndPackages: 'Auto generating groups and packages...',
    thisCouldTakeMinutes: 'Please wait, this may take several minutes',

    // 生成结果
    generationResults: 'Generation Results',
    processedGames: 'Processed Games:',
    createdGroups: 'Created Groups:',
    createdPackages: 'Created Packages:',
    successfullyProcessed: 'Successfully Processed:',
    failedProcessed: 'Failed Processed:',
    successRate: 'Success Rate: {{rate}}',
    operator: 'Operator: {{username}}',
    completed: 'Completed',

    platformUsers: 'NoizActiveUsers',
    platformUsersDesc: 'Noiz platform active users',

    // 主播包相关
    packageBasicInfo: 'Basic Information',
    packageName: 'Package Name',
    enterPackageName: 'Please enter package name...',
    packageDescription: 'Package Description',
    enterPackageDescription: 'Please enter package description...',
    packageSettings: 'Package Settings',
    maxStreamers: 'Max Streamers',
    priority: 'Priority',
    higherNumberHigherPriority: 'Higher number = higher priority',
    visibilityLevel: 'Visibility Level',
    tags: 'Tags',
    enterTagsCommaSeparated: 'Enter tags, separated by commas',
    tagsExample: 'e.g.: Premium, Popular, Beginner',
    streamerManagement: 'Streamer Management',
    currentlySelected: 'Currently selected {{count}} streamers',
    streamerListAutoGenerated: '* Streamer list will be auto-generated based on package settings and filter criteria',

    // 删除确认
    confirmDeletePackage: 'Confirm Delete Package',
    confirmDeletePackageMessage: 'Are you sure you want to delete package "{{name}}"?',
    cannotUndoOperation: '⚠️ This operation cannot be undone, all streamer data in the package will be cleared',
    deleting: 'Deleting...',
    confirmDelete: 'Confirm Delete',

    // 其他状态文本
    processing: 'Processing...',
    public: 'Public',
    private: 'Private',
    restricted: 'Restricted',
    create: 'Create',
    update: 'Update',
    refreshing: 'Refreshing...',

    // 数据加载成功提示
    loadedStreamersSuccess: 'Successfully loaded {{count}} streamers',
    loadedStreamerSuccess: 'Successfully loaded {{count}} streamer',
    loadDataFailed: 'Failed to load data',
    networkRequestFailed: 'Network request failed',

    syncGameTagsDesc: 'Recalculate and sync user game tags based on existing data in database',
    syncCurrentDataDesc: 'Calculate tags based on existing database data, no external data refresh needed',
    syncProcessTimeDesc: 'Sync time depends on user count and selected time ranges',
    syncProcessNote: 'Sync Instructions',
    pleaseSelectAtLeastOneRange: 'Please select at least one time range or check "Update All Ranges"',
    atLeastOneRangeRequired: 'At least one time range is required',
    syncSuccess: 'Sync successful! Processed {{count}} users in {{time}} seconds',
    syncGameTagsFailed: 'Failed to sync game tags',
    syncUserGameTagsFailed: 'Failed to sync user game tags',
    selectTimeRangeForTagUpdate: 'Please select time range tags to update, click "Sync" to start updating user game tags',
    selectUpdateRanges: 'Select tag ranges to update',
    canSelectMultipleRanges: 'Multiple selection allowed, will recalculate user game tags for selected time ranges',
    // Twitch 相关翻译
    openTwitchPage: 'Open Twitch Page',
    openSullyGnomeDataPage: 'Open SullyGnome Data Page',
    visitTwitchPage: 'Click to visit {{username}}\'s Twitch page',
    noTwitchInfo: 'No Twitch Info',

    // 统计弹窗相关翻译
    userStatistics: 'User Statistics',
    basicInfo: 'Basic Information',
    gamePreferences: 'Game Preferences',
    accountInfo: 'Account Information',
    username: 'Username',
    displayName: 'Display Name',
    registrationDate: 'Registration Date',
    lastActive: 'Last Active',
    accountType: 'Account Type',
    verificationStatus: 'Verification Status',
    verified: 'Verified',
    unverified: 'Unverified',

    // Twitch 信息
    twitchInfo: 'Twitch Information',
    twitchUsername: 'Twitch Username',
    twitchFollowers: 'Twitch Followers',
    twitchViews: 'Total Views',
    twitchCreatedAt: 'Twitch Created',
    averageViewers: 'Average Viewers',
    peakViewers: 'Peak Viewers',

    // 游戏标签
    gameTagsWeights: 'Game Tag Weights',
    genreTags: 'Genre Tags',
    themeTags: 'Theme Tags',
    tagWeight: 'Weight',
    noGameTags: 'No game tags available',

    // 主播评价
    streamerRatings: 'Streamer Ratings',
    activityRating: 'Activity Rating',
    completionRating: 'Completion Rating',
    costEffectivenessRating: 'Cost Effectiveness Rating',
    ratingCode: 'Rating Code',
    ratingDescription: 'Description',
    lastUpdated: 'Last Updated',
    noRatingsAvailable: 'No ratings available',

    // 统计数据
    statisticsData: 'Statistics Data',
    accvHistory: 'ACCV History (Last 30 Days)',
    followerGrowth: 'Follower Growth Trend',
    viewersCount: 'Viewers',
    followersCount: 'Followers',
    day: 'Day',
    date: 'Date',

    // 数据状态
    dataNotAvailable: 'Data not available',
    loadingData: 'Loading data...',
    noDataToDisplay: 'No data to display',

    // 匹配度相关
    matchAnalysis: 'Match Analysis',
    matchScore: 'Match Score',
    matchFactors: 'Match Factors',

    // 操作按钮
    refreshData: 'Refresh Data',
    exportData: 'Export Data',
    viewDetails: 'View Details',

    // 时间格式
    timeAgo: '{{time}} ago',
    justNow: 'Just now',
    minutesAgo: '{{minutes}} minutes ago',
    hoursAgo: '{{hours}} hours ago',
    daysAgo: '{{days}} days ago',
    monthsAgo: '{{months}} months ago',
    yearsAgo: '{{years}} years ago',

    // 统计弹窗相关翻译
    userStatistics: 'User Statistics',
    overview: 'Overview',
    gameTags: 'Game Tags',
    historicalTrend: 'Historical Trend',

    // 概览页面
    userOverview: 'User Overview',
    daysData: '{{days}}-day data',
    matchScore: 'Match Score',
    totalFollowers: 'Total Followers',
    avgViewers30: '30-day Average Viewers',
    totalGameTags: 'Total Game Tags',

    // 用户信息
    userInfo: 'User Information',
    username: 'Username',
    registrationTime: 'Registration Time',
    userStatus: 'User Status',
    region: 'Region',
    lastLogin: 'Last Login',
    languagePreference: 'Language Preference',
    platformBinding: 'Platform Binding',
    active: 'Active',
    inactive: 'Inactive',
    noInfo: 'No Info',
    bound: 'Bound {{count}}/4 platforms',
    excellent: 'Excellent',
    good: 'Good',
    few: 'Few',
    unbound: 'Unbound',
    noPlatformsBound: 'No platforms bound',

    // Twitch数据
    twitchData: 'Twitch Data',
    twitchUsername: 'Twitch Username',
    totalFollowers: 'Total Followers',
    accv30: '30-day ACCV',
    accv60: '60-day ACCV',
    accv90: '90-day ACCV',
    fanConversionRate: 'Fan Conversion Rate',
    lastUpdated: 'Last Updated',
    conversionRateDesc: '30-day average viewers ÷ total followers',
    noTwitchInfo: 'No Twitch Information',

    // 游戏标签概览
    gameTagsOverview: 'Game Tags Overview',
    gameGenres: 'Game Genres',
    gameThemes: 'Game Themes',
    highestWeightTag: 'Highest Weight Tag',
    dataRange: 'Data Range',
    avgMatchRate: 'Average Match Rate',

    // 数据趋势
    accvTimeTrend: 'ACCV Time Trend',
    accvTrendDesc: 'Comparison of average concurrent viewers across different time ranges',
    viewerDataAnalysis: 'Viewer Data Analysis',
    viewerAnalysisDesc: 'Analysis of follower base and viewer activity',
    currentFollowers: 'Current Followers',
    avgViewers30Day: '30-day Viewers',
    conversionRate: 'Conversion Rate',
    dataInterpretation: 'Data Interpretation:',
    conversionRateFormula: '• Conversion Rate = 30-day average viewers ÷ total followers × 100%',
    conversionRateIndicator: '• Higher conversion rate indicates better follower engagement',
    viewerTrendDesc: '• Viewer trend reflects streaming performance across different periods',
    conversionRateEvaluation: 'Conversion Rate Evaluation',
    excellentConversion: '✅ Excellent conversion rate',
    goodConversion: '⚠️ Good conversion rate',
    lowConversion: '❌ Low conversion rate',

    // 趋势分析
    trendAnalysis: 'Trend Analysis',
    continuousUptrend: '📈 Continuous upward trend, excellent performance',
    continuousDowntrend: '📉 Continuous downward trend, needs attention',
    recentImprovement: '📊 Recent performance improvement, promising',
    recentDecline: '📊 Recent performance decline, suggest optimization',
    relativelyStable: '📊 Relatively stable performance',

    // 主播评价概览
    streamerRatingOverview: 'Streamer Rating Overview',
    activityRating: 'Activity Rating',
    executionRating: 'Execution Rating',
    costEffectRating: 'Cost-Effect Rating',

    // 游戏标签页面
    tagStatsOverview: 'Tag Statistics Overview',
    gameGenres: 'Game Genres',
    gameThemes: 'Game Themes',
    totalWeight: 'Total Weight',
    avgMatchRate: 'Average Match Rate',
    gameGenreDistribution: 'Game Genre Distribution',
    gameThemeDistribution: 'Game Theme Distribution',
    tags: 'tags',
    genreTagDetails: 'Genre Tag Details',
    themeTagDetails: 'Theme Tag Details',
    weight: 'Weight',
    match: 'Match',
    tagWeightRanking: 'Tag Weight Ranking',
    top: 'Top',
    topN: 'Top {{count}}',
    noTagData: 'No tag data available',
    expand: 'Expand',
    collapse: 'Collapse',

    // 游戏列表
    gameList: 'Game List',
    games: 'games',
    gameName: 'Game Name',
    playTime: 'Play Time',
    releaseTime: 'Release Time',
    dataSyncTime: 'Data Sync Time',
    clickToVisitIGDB: 'Click to visit IGDB game page',
    noGameData: 'No game data available',
    noGameRecords: 'This user has no game records in {{days}} days',

    // 游戏统计
    gameStatsOverview: 'Game Statistics Overview',
    totalGames: 'Total Games',
    totalPlayTime: 'Total Play Time',
    avgPlayTime: 'Average Play Time',
    recentNewGames: 'Recent New Games',

    // 历史趋势页面
    historicalTrendAnalysis: 'Historical Trend Analysis',
    historicalTrendDesc: 'Display user\'s ACCV data comparison across different time periods to understand performance trends.',
    accvDataOverview: 'ACCV Data Overview',
    dayAverage: '{{days}}-day average',
    audienceFollowerData: 'Audience & Follower Data',
    dataExplanation: 'Data Explanation',
    accvTimeComparison: 'ACCV Time Period Comparison',
    dataDetails: 'Data Details',
    timeRange: 'Time Range',
    relativeChange: 'Relative Change',
    dataStatus: 'Data Status',
    baseline: 'Baseline',
    hasData: 'Has Data',
    noData: 'No Data',
    dataNote: 'Data Note',
    dataNote1: '• ACCV (Average Concurrent Viewers): Average concurrent viewer count, reflects streamer\'s influence',
    dataNote2: '• Currently system records 30-day, 60-day, 90-day ACCV data',
    dataNote3: '• Fan conversion rate = 30-day average viewers ÷ total followers, higher value indicates better fan engagement',
    dataNote4: '• Relative change uses 30-day data as baseline, positive values indicate better historical performance, negative values indicate recent improvement',

    // 时间格式
    minutes: 'minutes',
    hours: 'hours',
    days: 'days',
    unknown: 'Unknown',
    notSynced: 'Not Synced',

    // 数字格式
    thousandAbbrev: 'K',
    millionAbbrev: 'M',
    billionAbbrev: 'B',

    // 添加缺失的性价比相关翻译
    costEffectivenessEvaluation: 'Cost Effectiveness Evaluation',
    currentCostEffectivenessLevel: 'Current Cost Effectiveness Level',
    costEffectivenessFormula: 'Cost Effectiveness Formula',

    // 性价比等级
    ultraHighCostEffective: 'Ultra High Cost-Effective',
    highCostEffective: 'High Cost-Effective',
    mediumCostEffective: 'Medium Cost-Effective',
    normalCostEffective: 'Normal Cost-Effective',
    needsImprovement: 'Needs Improvement',

    // 平台数据对比
    platformDataComparison: 'Platform Data Comparison',
    recentApplicationCount: 'Recent {{days}}-day Application Count',
    recentCompletionCount: 'Recent {{days}}-day Completion Count',
    recentCompletionRate: 'Recent {{days}}-day Completion Rate',
    recentAverageReward: 'Recent {{days}}-day Average Reward',
    userValue: 'User Value',
    platformAverage: 'Platform Average',
    vs: 'vs',
    abovePlatformAvg: 'above platform average',
    belowPlatformAvg: 'below platform average',
    taskCompletionRate: 'Task Completion Rate',

    // 主播评价概览
    streamerRatingOverview: 'Streamer Rating Overview',
    activityRating: 'Activity Rating',
    executionRating: 'Execution Rating',
    costEffectiveRating: 'Cost-Effective Rating',

    // 数据状态
    dataNotAvailable: 'Data Not Available',
    noInfo: 'No Info',

    // 时间相关
    lastUpdated: 'Last Updated',

    // 添加 stableTrend 翻译
    stableTrend: '📊 Stable trend, consistent performance',

    // 其他缺失的翻译
    risingTrend: '📈 Rising trend, excellent performance',
    decliningTrend: '📉 Declining trend, needs attention',
    recentImprovement: '📊 Recent performance improvement',
    recentDecline: '📊 Recent performance decline, suggest optimization',
    relativelyStable: '📊 Relatively stable performance',

    // 补充缺失的英文翻译
    accvTimeTrendDesc: 'Comparison of average concurrent viewers across different time ranges',
    audienceDataAnalysis: 'Audience Data Analysis',
    audienceDataAnalysisDesc: 'Analysis of follower base and viewer activity',

    // 性价比评估条件 - 英文
    ultraHighCostEffectiveCondition: 'Task average reward ÷ (followers × ACCV) ≤ platform average × 0.5\nTask completion rate ≥ 70%',
    highCostEffectiveCondition: 'Task average reward ÷ (followers × ACCV) ≤ platform average\nTask completion rate ≥ 60%',
    mediumCostEffectiveCondition: 'Task average reward ÷ (followers × ACCV) ≤ platform average × 1.5\nTask completion rate ≥ 50%',
    normalCostEffectiveCondition: 'Task average reward ÷ (followers × ACCV) ≤ platform average × 1.5\nTask completion rate 25%-50%',
    needsImprovementCondition: 'Task average reward ÷ (followers × ACCV) > platform average × 1.5\nor Task completion rate < 25%',

    // 粉丝转化率说明 - 英文
    fanConversionRateFormula: 'Fan conversion rate = 30-day average viewers ÷ total followers × 100%',
    fanConversionRateDesc: 'This indicator reflects fan engagement and loyalty',

    // 趋势分析 - 英文
    historicalTrend: 'Historical Trend',
    recentImprovement: 'Recent performance improvement',
    recentDecline: 'Recent performance decline',

    // 平台绑定相关 - 英文
    unbound: 'Unbound:',
    boundPlatforms: 'Bound platforms',

    // 筛选相关 - 英文
    clearAllFilters: 'Clear All Filters',

    // 其他缺失的英文翻译
    audienceFollowerData: 'Audience & Follower Data',
    historicalTrendAnalysis: 'Historical Trend Analysis',

    insufficientData: 'Insufficient Data',
    insufficientDataDesc: 'Not enough data available for evaluation',

    missingFollowersOrAccvData: 'Missing followers or ACCV data',
    cannotCalculateCostEffectiveness: 'Cannot calculate cost effectiveness',
    missingFollowersData: 'Missing followers data',
    missingAccvData: 'Missing ACCV data',
    missingBothFollowersAndAccv: 'Missing both followers and ACCV data',
    dataRequiredForCalculation: 'Followers and ACCV data required for cost effectiveness calculation',

    // 主播类型 - 添加未分类
    unlimited: 'Unlimited',
    premiumStreamer: 'Premium',
    potentialStreamer: 'Potential',
    normalStreamer: 'Normal',
    otherStreamers: 'Other',
    unclassifiedStreamer: 'Unclassified', // 新增未分类
    // 新增：主播包加载相关翻译
    loadingStreamerPackageData: 'Loading streamer package data...',

    taskInvitationResults: 'Task Invitation Results',
    sendResultsOverview: 'Send Results Overview',
    successfulSent: 'Successfully Sent',
    alreadyJoinedTasks: 'Already Joined Tasks',
    sendFailed: 'Send Failed',
    totalProcessed: 'Total Processed',
    detailedInformation: 'Detailed Information',
    statusExplanation: 'Status Explanation:',
    successfulSentDesc: 'Email has been successfully sent to user',
    alreadyJoinedTasksDesc: 'User has already joined the selected tasks, no need for duplicate invitation',
    sendFailedDesc: 'Failed to send due to network, email or other issues',
    skippingUsersOptimization: 'For users who have already joined tasks, the system will automatically skip sending, this is normal optimization behavior',
    confirm: 'Confirm',

    recentDaysData: 'Recent {{days}} days data',
  },
  zh: {
    // 筛选相关
    timeRange: '时间范围：',
    game: '游戏：',
    allGames: '全部游戏',
    sort: '排序：',
    search: '搜索：',
    searchPlaceholder: '搜索用户名或Twitch用户名...',
    more: '更多',
    gameTags: '游戏标签',
    gameType: '游戏类型：',
    gameTheme: '游戏主题：',
    addType: '添加类型',
    addTheme: '添加主题',

    // 用户列表相关
    userList: '用户列表 ({{count}} 个用户)',
    selectedUsers: '- 已选择 {{count}} 个',
    oneClickSelect: '一键选择',
    addToPackage: '添加到主播包',
    clearSelection: '清除选择',

    // 排序选项
    matchScore: '匹配度',
    activityLevel: '活跃度',
    executionAbility: '执行力',
    costEffectiveness: '性价比',
    followers: '粉丝数',
    avgViewers: '平均观众',

    // 数据加载成功提示
    loadedStreamersSuccess: '成功加载了{{count}}个主播',
    loadedStreamerSuccess: '成功加载了{{count}}个主播',
    loadDataFailed: '加载数据失败',
    networkRequestFailed: '网络请求失败',

    // 评价标签
    activity: '活跃度',
    execution: '执行力',
    costEffect: '性价比',
    noRating: '无评价',

    // 消息
    loadingUsers: '正在加载用户数据...',
    noUsers: '没有找到匹配的用户',
    addedToSelection: '已添加当前页面的 {{count}} 个用户到选择列表',
    clearedSelection: '已取消选择 {{count}} 个用户',

    // 语言相关
    languageSettings: '语言设置',
    interfaceLanguage: '界面语言',
    contentLanguage: '内容语言',
    autoDetect: '自动检测',

    // 添加对应的中文翻译
    language: '语言',
    streamerFilterSystem: '主播包筛选系统',
    streamerGroupManagement: '主播包分组管理',
    streamerPackageSystem: '主播包管理系统',
    groupList: '分组列表',
    addGroup: '添加分组',
    loadingGroups: '正在加载分组...',
    noGroups: '暂无分组数据',
    memberCount: '{{count}} 个成员',
    edit: '编辑',
    delete: '删除',
    days: '天',
    tags: '标签',
    noTags: '无标签',
    search: '搜索',
    rowsPerPage: '每页行数:',
    displayedRows: '{{from}}-{{to}} / 共 {{count}}',
    close: '关闭',
    current: '当前',

    // 添加对应的中文翻译
    totalGames: '游戏总数',
    totalGroups: '分组总数',
    totalPackages: '包总数',
    totalStreamers: '主播总数',
    existingGroups: '现有分组 ({{count}} 个)',
    streamers: '主播',
    packages: '主播包',
    viewExpectedData: '查看预期数据',
    sendTaskInvitation: '发送任务邀约',
    viewDays: '查看天数:',
    switchingToPackage: '正在切换到"{{name}}"...',
    loadingStreamerData: '正在加载主播数据...',
    streamerList: '主播列表 ({{count}} 个主播)',
    selected: '已选择 {{count}} 个',
    oneClickSelect: '一键选择',
    transferToOtherPackage: '转移到其他包 ({{count}})',
    deleteSelected: '删除选中 ({{count}})',
    clearSelection: '清除选择',
    selectedStreamers: '选中的主播：',
    noOtherPackagesAvailable: '⚠️ 当前分组没有其他可用的主播包，无法进行转移操作',
    noStreamers: '暂无主播',
    noStreamersInPackage: '此主播包暂时没有添加任何主播',
    pleaseSelectGroupAndPackage: '请选择分组和主播包',
    selectGroupAndPackageToView: '选择左侧的分组和主播包来查看主播列表',
    packageNotExists: '主播包不存在',
    currentSelectedPackageInvalid: '当前选择的主播包索引无效',
    searchGroups: '搜索分组...',
    groupManagementHome: '分组管理首页',
    refreshing: '刷新中...',
    noMatchingGroups: '未找到匹配的分组',
    noGroupData: '暂无分组数据',
    createPackage: '创建包',
    editPackage: '编辑包',
    deletePackage: '删除包',
    confirmDeletePackage: '确认删除主播包',
    confirmDeletePackageMessage: '确定要删除主播包 "{{name}}" 吗？',
    cannotUndoOperation: '⚠️ 此操作不可撤销，包中的所有主播数据将被清除',
    deleting: '删除中...',
    confirmDelete: '确认删除',
    autoGenerateDefaultGroups: '自动生成默认分组',
    packageBasicInfo: '基本信息',
    packageName: '包名称',
    enterPackageName: '请输入主播包名称...',
    packageDescription: '包描述',
    enterPackageDescription: '请输入主播包描述...',
    packageSettings: '包设置',
    maxStreamers: '最大主播数',
    priority: '优先级',
    higherNumberHigherPriority: '数值越大优先级越高',
    visibilityLevel: '可见性级别',
    tags: '标签',
    enterTagsCommaSeparated: '输入标签，用逗号分隔',
    tagsExample: '例如: 优质, 热门, 新手',
    streamerManagement: '主播管理',
    currentlySelected: '当前选择了 {{count}} 个主播',
    streamerListAutoGenerated: '* 主播列表将根据包的设置和筛选条件自动生成',
    packageStats: '包统计信息:',
    actualStreamers: '实际主播数: {{count}}',
    averageViewers: '平均观众数: {{count}}',
    totalFollowers: '总粉丝数: {{count}}',
    calculationPeriod: '统计周期: {{period}}',
    processing: '处理中...',
    create: '创建',
    update: '更新',
    public: '公开',
    private: '私有',
    restricted: '受限',
    transferUsersToOtherPackage: '转移用户到其他主播包',
    transferInfo: '转移信息',
    gameGroup: '游戏分组：',
    currentPackage: '当前主播包：',
    selectedUsersCount: '选中用户数：',
    selectTargetPackage: '选择目标主播包',
    transferInstructions: '转移说明:',
    transferInstruction1: '• 用户将从当前主播包中移除，并添加到目标主播包',
    transferInstruction2: '• 转移操作不可撤销，请确认选择正确的目标包',
    transferInstruction3: '• 转移完成后会自动刷新数据',
    confirmTransfer: '确认转移',
    transferring: '转移中...',
    noActiveQuests: '暂无活跃任务',
    noActiveQuestsForGame: '当前游戏没有可用的活跃任务',
    loadingActiveQuests: '正在加载活跃任务...',
    sendTaskInvitationTo: '即将发送给 {{count}} 个主播：',
    selectTasksToSend: '选择要发送的任务',
    totalTasks: '共 {{total}} 个任务，已选择 {{selected}} 个',
    selectAllTasks: '全选任务',
    deselectAllTasks: '取消全选',
    taskOverview: '任务概览',
    totalTasksCount: '总任务',
    selectedTasks: '已选择',
    streamingTasks: '直播任务',
    creationTasks: '二创任务',
    urgentTasks: '紧急任务',
    startTime: '开始时间',
    endTime: '结束时间',
    taskType: '任务类型',
    requiredStreamTime: '直播时长要求',
    notSet: '未设置',
    noRequirement: '无要求',
    streamingTask: '直播任务',
    creationTask: '二创任务',
    contentCreation: '内容创作',
    promotionTask: '推广任务',
    eventTask: '活动任务',
    unknownType: '未知类型',
    urgent: '紧急',
    minimumViewers: '最低观众: {{count}}',
    rewards: '奖励:',
    sendPreview: '发送预览：',
    willSendInvitationEmail: '将向 {{userCount}} 个主播发送包含 {{taskCount}} 个任务的邀约邮件',
    selectedTasksList: '选中的任务：',
    sendInvitation: '发送邀约 ({{count}} 个主播)',
    sending: '发送中...',
    minutes: '分钟',
    hours: '小时',
    days: '天',
    unknownUser: '未知用户',
    expectedDataStats: '预期数据统计',
    statsOverview: '统计概览',
    group: '分组：',
    package: '主播包：',
    statsPeriod: '统计周期：',
    calculationTime: '计算时间：',
    streamersCount: '主播数量',
    averageCCV: '平均观众数',
    peakCCV: '峰值观众数',
    totalFollowersCount: '总粉丝数',
    detailedStats: '详细统计数据',
    streamingTimeStats: '直播时间统计',
    totalStreamingTime: '累计直播时间:',
    avgStreamingTimePerStreamer: '人均直播时间:',
    viewingDataStats: '观看数据统计',
    totalViewingTime: '累计观看时间:',
    vodViews: 'VOD观看次数:',
    dataExplanation: '数据说明:',
    dataNote1: '• 以上数据基于所选主播在近{{days}}天的历史表现进行计算和预测',
    dataNote2: '• 平均观众数(Average CCV)基于主播的ACCV数据计算',
    dataNote3: '• 峰值观众数、观看时间等指标基于历史数据和算法模型预测',
    dataNote4: '• 实际数据可能因主播表现、游戏热度等因素有所差异',
    calculatingExpectedData: '正在计算预期数据...',
    basedOnRecentDaysData: '基于近{{days}}天的主播数据进行分析',
    dataCalculationFailed: '数据计算失败',
    retryOrContactSupport: '请重试或联系技术支持',
    refreshData: '刷新数据',
    // 新增翻译
    autoGenerateComplete: '自动生成完成：创建了 {{groups}} 个分组和 {{packages}} 个主播包',
    noNewGroupsOrPackages: '没有需要创建的新分组或主播包',
    autoGenerationFailed: '自动生成失败: {{error}}',
    processingAutoGeneration: '正在自动生成分组和主播包...',
    thisOperationWillCreate: '此操作将为所有符合条件的游戏自动创建默认分组和默认主播包。',
    onlyCreateForGamesWithoutDefault: '• 只会为没有默认分组的游戏创建新分组',
    onlyCreateForGroupsWithoutDefault: '• 只会为没有默认主播包的分组创建新主播包',
    onlyProcessActiveGamesWithTwitch: '• 只处理状态为"active"且有nameInTwitch的游戏',
    operationCannotBeUndone: '⚠️ 此操作不可撤销，请谨慎操作',
    generating: '生成中...',
    autoGeneratingGroupsAndPackages: '正在自动生成分组和主播包...',
    thisCouldTakeMinutes: '请稍候，这可能需要几分钟时间',
    generationResults: '生成结果',
    processedGames: '处理的游戏数量:',
    createdGroups: '创建的分组数量:',
    createdPackages: '创建的主播包数量:',
    successfullyProcessed: '成功处理:',
    failedProcessed: '处理失败:',
    successRate: '成功率: {{rate}}',
    operator: '操作者: {{username}}',
    startGeneration: '开始生成',
    completed: '完成',
    //----------- 主播包补充翻译的-------------
    // 时间范围
    '30days': '30天',
    '60days': '60天',
    '90days': '90天',
    '120days': '120天',
    '365days': '365天',
    'days': '天',

    // 筛选相关
    timeRange: '时间范围：',
    game: '游戏：',
    allGames: '全部游戏',
    sort: '排序：',
    search: '搜索：',
    searchPlaceholder: '搜索用户名或Twitch用户名...',
    more: '更多',
    gameTags: '游戏标签',
    gameType: '游戏类型：',
    gameTheme: '游戏主题：',
    addType: '添加类型',
    addTheme: '添加主题',

    // 排序选项
    matchScore: '匹配度',
    activityLevel: '活跃度',
    executionAbility: '执行力',
    costEffectiveness: '性价比',
    followers: '粉丝数',
    avgViewers: '平均观众',

    // 主播类型
    streamerType: '主播类型：',
    unlimited: '不限',
    premiumStreamer: '优质主播',
    potentialStreamer: '潜力主播',
    normalStreamer: '普通主播',
    otherStreamers: '其他主播',

    // 卡片内容
    followersLabel: '粉丝',
    activity: '活跃度',
    execution: '执行力',
    costEffect: '性价比',
    matchDegree: '匹配度',
    noRating: '无评价',

    // 搜索按钮
    searchBtn: '搜索',

    // More 菜单项
    syncStreamerRatings: '同步主播评价标签',
    syncGameTags: '同步游戏标签',
    syncGameInfo: '同步游戏信息',

    // 弹窗内容 - 主播评价体系管理
    streamerRatingSystemManagement: '主播评价体系管理',
    syncTags: '同步标签',
    systemConfig: '系统配置',
    syncStreamerRatingTags: '同步主播评价标签',
    syncAllStreamerRatingDesc: '同步所有主播的评价标签数据，包括活跃度、完成能力和成本效益等评价指标。',
    currentConfigOverview: '当前配置概览',
    tagTypesCount: '标签类型总数',
    activeTagsCount: '活跃标签数',
    totalTagsCount: '总标签数',
    tagTypesOverview: '标签类型概览',
    noConfigData: '暂无配置数据',
    syncOptionSettings: '同步选项设置',
    forceUpdateAllUsers: '强制更新所有用户',
    forceUpdateDesc: '勾选后将强制更新所有主播的评价标签，包括已有评价的用户。不勾选时将跳过已有评价的用户，只更新新用户或评价缺失的用户。',
    startSyncTags: '开始同步标签',
    viewDetailedConfig: '查看详细配置',
    forceUpdateMode: '强制更新模式：将重新计算所有主播的评价标签，这个过程可能需要较长时间。',
    smartUpdateMode: '智能更新模式：只更新新用户或评价缺失的用户，可以节省时间。',
    tagTypeConfig: '标签类型配置',
    cancel: '取消',
    save: '保存',
    saving: '保存中...',
    saveTypeConfig: '保存类型配置',
    editTypeConfig: '编辑类型配置',
    typeCode: '类型编码',
    typeName: '类型名称',
    defaultStatDays: '默认统计天数',
    description: '说明',
    noTagTypeData: '暂无标签类型数据',
    tagDetailedConfig: '标签详细配置',
    saveTagConfig: '保存标签配置',
    editTagConfig: '编辑标签配置',
    initializeSystem: '初始化系统',
    initializing: '初始化中...',
    tagCode: '标签编码',
    tagName: '标签名称',
    category: '分类',
    registrationTime: '注册时间',
    recentApplicationDays: '申请统计天数',
    applicationRatio: '申请比例',
    recentCompletionDays: '完成统计天数',
    completionRatio: '完成比例',
    completionRateRatio: '完成率比例',
    rewardRatio: '报酬比例',
    priority: '优先级',
    status: '状态',
    enabled: '启用',
    disabled: '禁用',
    noTagConfigData: '暂无标签配置数据',
    editInstructions: '编辑说明：',
    editInstructionsDesc: '• 标签类型配置：可编辑默认统计天数和说明\n• 标签详细配置：可编辑标签名称和注册时间区间\n• 110-150标签：可编辑申请比例区间\n• 210-250标签：可编辑完成比例和完成率比例区间\n• 310-350标签：可编辑完成率比例和报酬比例区间',

    // 弹窗内容 - 游戏标签同步
    syncGameTagsTitle: '同步游戏标签',
    selectGameTagTimeRange: '选择要同步的游戏标签时间范围，系统将重新计算选中时间范围内的用户游戏偏好标签。',
    updateAllTimeRanges: '更新所有时间范围',
    updateAllTimeRangesDesc: '勾选后将更新所有时间范围（30、60、90、120、365天）的标签，忽略下方的具体选择。',
    selectGameTagRanges: '选择游戏标签范围（可多选）：',
    allRangesSelected: '已选择更新所有范围，下方选择将被忽略',
    pleaseSelectAtLeastOne: '请至少选择一个时间范围',
    willUpdateAllRanges: '将更新所有时间范围（30、60、90、120、365天）的标签',
    selectedRanges: '已选择 {{count}} 个时间范围: {{ranges}}天',
    syncLatestData: '同步最新数据',
    syncLatestDataDesc: '如勾选，将从数据源获取最新游戏数据后重新计算标签。取消勾选仅基于现有数据重新计算标签，不更新游戏数据。',
    syncProcessDesc: '同步过程可能需要几分钟时间，时间取决于用户数量和所选范围。',
    updateAllRangesTakeLonger: '更新所有范围可能需要更长时间。',
    startSync: '开始同步',
    syncing: '同步中...',

    // 弹窗内容 - 游戏信息同步
    gameIGDBInfoSync: '游戏IGDB信息同步',
    syncConfig: '同步配置',
    selectGameSource: '选择游戏来源',
    allGames: '所有游戏',
    noizPlatformGames: 'Noiz平台游戏',
    nonNoizPlatformGames: '非Noiz平台游戏',
    allGamesDesc: '从UserGame表获取所有游戏数据',
    noizGamesDesc: '从Game表获取平台认证的游戏',
    nonNoizGamesDesc: '排除平台游戏的其他游戏',
    statDays: '统计天数',
    syncMode: '同步模式',
    smartSync: '智能同步（仅未同步）',
    forceSync: '强制同步（仅已同步）',
    fullSync: '全量同步（所有游戏）',
    searchGames: '搜索游戏...',
    searchGame: '搜索游戏',
    statsOverview: '统计概览',
    loadingData: '正在加载数据...',
    totalGamesCount: '总游戏数',
    synced: '已同步',
    unsynced: '未同步',
    syncRate: '同步率',
    gameList: '游戏列表',
    selectAll: '全选',
    deselectAll: '取消全选',
    selectedCount: '已选择 {{count}} 个',
    gameListEmpty: '没有找到匹配的游戏',
    loadingGameData: '正在加载游戏数据...',
    noGameData: '没有找到游戏',
    operationInstructions: '操作说明',
    operationInstructionsDesc: '• 选择游戏后点击"开始同步"，未选择则同步所有符合条件的游戏\n• 智能同步：跳过已有IGDB信息的游戏\n• 强制同步：重新获取已有IGDB信息的游戏\n• 全量同步：处理所有游戏，根据现有状态决定是否覆盖',
    syncInProgress: '同步中...',
    syncIGDBInfo: '开始同步',
    currentProcessing: '当前: {{game}}',
    progress: '进度: {{processed}}/{{total}}',

    // 用户列表相关
    userList: '用户列表 ({{count}} 个用户)',
    selectedUsers: '- 已选择 {{count}} 个',
    oneClickSelect: '一键选择',
    addToPackage: '添加到主播包',
    clearSelection: '清除选择',

    // 消息
    loadingUsers: '正在加载用户数据...',
    noUsers: '没有找到匹配的用户',
    addedToSelection: '已添加当前页面的 {{count}} 个用户到选择列表',
    clearedSelection: '已取消选择 {{count}} 个用户',

    // 语言相关
    languageSettings: '语言设置',
    interfaceLanguage: '界面语言',
    contentLanguage: '内容语言',
    autoDetect: '自动检测',

    // 只添加真正缺失的翻译
    addToStreamerPackage: '添加到主播包',
    selectedUsersCount: '已选择 {{count}} 个用户',
    selectedUsersList: '选中用户列表：',
    typeDistribution: '类型分布：',
    selectionPersistence: '选择持久化：用户选择会在翻页、筛选时保持，可手动点击标签删除图标移除单个用户',
    clickToAddToPackage: '点击"添加到主播包"可将选中的用户批量添加到指定的游戏主播包中',

    currentFilters: '当前筛选条件',
    clearAllFilters: '清除所有筛选',
    filterPersistence: '筛选结果将在翻页时保持',

    match: '匹配度',
    viewStats: '查看统计',

    // 主播包弹窗相关
    addUsersToStreamerPackage: '添加用户到主播包',
    aboutToAdd: '即将添加 {{count}} 个用户到主播包：',
    searchAndSelectGameGroup: '1. 搜索并选择游戏分组',
    enterGameNameToSearch: '输入游戏名称进行搜索...',
    selectedGame: '已选择游戏：',
    defaultGroup: '默认分组: {{groupName}}',
    autoSelectedDefaultGroup: '已自动选择默认分组，找到 {{count}} 个可用主播包',
    selectStreamerPackage: '2. 选择主播包',
    pleaseSelectGameFirst: '请先选择游戏',
    gameHasNoDefaultGroup: '该游戏没有默认分组',
    selectStreamerPackageOption: '选择主播包',
    noAvailablePackages: '该分组暂无可用主播包',
    addPreview: '添加预览：',
    willAddUsersToPackage: '将向"{{packageName}}"主播包添加 {{userCount}} 个用户',
    packageCurrently: '主播包当前有 {{current}} 个主播，添加后将有 {{total}} 个（限制：{{max}}）',
    operationDescription: '操作说明：选择游戏后会自动选择该游戏的默认分组，然后您可以选择分组下的主播包',
    adding: '添加中...',
    addUsers: '添加 {{count}} 个用户',

    // IGDB同步进度相关
    syncingIGDBInfo: '正在同步IGDB信息...',
    currentProcessing: '当前处理: {{game}}',

    // 用户相关
    noRatingData: '无评价数据',
    unknownUser: '未知用户',

    // 数据相关
    gameCount: '{{count}} 个游戏',
    tagCount: '{{count}} 个标签',
    userCount: '{{count}} 个用户',
    items: '项',

    // 添加平台用户相关翻译
    platformUsers: '平台用户',
    platformUsersDesc: '经过平台验证和管理的用户',
    onlyShowPlatformUsers: '只显示平台用户',
    allUsers: '全部用户',
    // 平台用户筛选
    // 数据加载页面
    loadingStreamerGroupData: '正在加载主播分组数据...',
    loadingLatestGroupInfo: '请稍候，正在获取最新的分组和主播信息',

    // 左侧栏
    streamers: '主播',
    streamer: '主播',
    streamersCount: '{{count}} 个主播',
    streamerCount: '{{count}} 个主播',

    // 自动生成相关
    autoGenerateDefaultGroups: '自动生成默认分组',
    autoGenerateDefaultGroupsAndPackages: '自动生成默认分组和主播包',
    thisOperationWillCreate: '此操作将为所有符合条件的游戏自动创建默认分组和默认主播包。',
    onlyCreateForGamesWithoutDefault: '• 只会为没有默认分组的游戏创建新分组',
    onlyCreateForGroupsWithoutDefault: '• 只会为没有默认主播包的分组创建新主播包',
    onlyProcessActiveGamesWithTwitch: '• 只处理状态为"active"且有nameInTwitch的游戏',
    operationCannotBeUndone: '⚠️ 此操作不可撤销，请谨慎操作',
    cancel: '取消',
    startGeneration: '开始生成',
    generating: '生成中...',
    autoGeneratingGroupsAndPackages: '正在自动生成分组和主播包...',
    thisCouldTakeMinutes: '请稍候，这可能需要几分钟时间',

    // 生成结果
    generationResults: '生成结果',
    processedGames: '处理的游戏数量:',
    createdGroups: '创建的分组数量:',
    createdPackages: '创建的主播包数量:',
    successfullyProcessed: '成功处理:',
    failedProcessed: '处理失败:',
    successRate: '成功率: {{rate}}',
    operator: '操作者: {{username}}',
    completed: '完成',

    // 主播包相关
    packageBasicInfo: '基本信息',
    packageName: '包名称',
    enterPackageName: '请输入主播包名称...',
    packageDescription: '包描述',
    enterPackageDescription: '请输入主播包描述...',
    packageSettings: '包设置',
    maxStreamers: '最大主播数',
    priority: '优先级',
    higherNumberHigherPriority: '数值越大优先级越高',
    visibilityLevel: '可见性级别',
    tags: '标签',
    enterTagsCommaSeparated: '输入标签，用逗号分隔',
    tagsExample: '例如: 优质, 热门, 新手',
    streamerManagement: '主播管理',
    currentlySelected: '当前选择了 {{count}} 个主播',
    streamerListAutoGenerated: '* 主播列表将根据包的设置和筛选条件自动生成',

    // 删除确认
    confirmDeletePackage: '确认删除主播包',
    confirmDeletePackageMessage: '确定要删除主播包 "{{name}}" 吗？',
    cannotUndoOperation: '⚠️ 此操作不可撤销，包中的所有主播数据将被清除',
    deleting: '删除中...',
    confirmDelete: '确认删除',

    // 其他状态文本
    processing: '处理中...',
    public: '公开',
    private: '私有',
    restricted: '受限',
    create: '创建',
    update: '更新',
    refreshing: '刷新中...',

    // 游戏标签同步相关
    syncGameTagsDesc: '基于数据库中的现有数据重新计算和同步用户的游戏标签',
    syncCurrentDataDesc: '基于数据库现有数据进行标签计算，无需重新获取外部数据',
    syncProcessTimeDesc: '同步时间取决于用户数量和选择的时间范围',
    syncProcessNote: '同步说明',
    pleaseSelectAtLeastOneRange: '请至少选择一个时间范围或勾选"更新所有范围"',
    atLeastOneRangeRequired: '至少需要选择一个时间范围',
    syncSuccess: '同步成功！处理了 {{count}} 个用户，用时 {{time}} 秒',
    syncGameTagsFailed: '同步游戏标签失败',
    syncUserGameTagsFailed: '同步用户游戏标签失败',
    selectTimeRangeForTagUpdate: '请选择需要更新的时间范围标签，点击"同步"按钮开始更新用户游戏标签数据',
    selectUpdateRanges: '选择要更新的标签范围',
    canSelectMultipleRanges: '可多选，将重新计算选中时间范围的用户游戏标签',
    // Twitch 相关翻译
    openTwitchPage: '打开 Twitch 页面',
    openSullyGnomeDataPage: '打开 SullyGnome 数据页面',
    visitTwitchPage: '点击访问 {{username}} 的 Twitch 页面',
    noTwitchInfo: '无 Twitch 信息',

    // 统计弹窗相关翻译
    userStatistics: '用户统计',
    basicInfo: '基本信息',
    gamePreferences: '游戏偏好',
    accountInfo: '账户信息',
    username: '用户名',
    displayName: '显示名称',
    registrationDate: '注册日期',
    lastActive: '最后活跃',
    accountType: '账户类型',
    verificationStatus: '验证状态',
    verified: '已验证',
    unverified: '未验证',

    // Twitch 信息
    twitchInfo: 'Twitch 信息',
    twitchUsername: 'Twitch 用户名',
    twitchFollowers: 'Twitch 粉丝',
    twitchViews: '总观看次数',
    twitchCreatedAt: 'Twitch 创建时间',
    averageViewers: '平均观众',
    peakViewers: '峰值观众',

    // 游戏标签
    gameTagsWeights: '游戏标签权重',
    genreTags: '类型标签',
    themeTags: '主题标签',
    tagWeight: '权重',
    noGameTags: '暂无游戏标签',

    // 主播评价
    streamerRatings: '主播评价',
    activityRating: '活跃度评价',
    completionRating: '完成度评价',
    costEffectivenessRating: '性价比评价',
    ratingCode: '评价代码',
    ratingDescription: '说明',
    lastUpdated: '最后更新',
    noRatingsAvailable: '暂无评价数据',

    // 统计数据
    statisticsData: '统计数据',
    accvHistory: 'ACCV 历史 (近30天)',
    followerGrowth: '粉丝增长趋势',
    viewersCount: '观众数',
    followersCount: '粉丝数',
    day: '天',
    date: '日期',

    // 数据状态
    dataNotAvailable: '数据不可用',
    loadingData: '正在加载数据...',
    noDataToDisplay: '暂无数据显示',

    // 匹配度相关
    matchAnalysis: '匹配度分析',
    matchScore: '匹配度',
    matchFactors: '匹配因子',

    // 操作按钮
    refreshData: '刷新数据',
    exportData: '导出数据',
    viewDetails: '查看详情',

    // 时间格式
    timeAgo: '{{time}}前',
    justNow: '刚刚',
    minutesAgo: '{{minutes}}分钟前',
    hoursAgo: '{{hours}}小时前',
    daysAgo: '{{days}}天前',
    monthsAgo: '{{months}}个月前',
    yearsAgo: '{{years}}年前',

    // 统计弹窗相关翻译
    userStatistics: '用户统计',
    overview: '概览',
    gameTags: '游戏标签',
    historicalTrend: '历史趋势',

    // 概览页面
    userOverview: '用户概览',
    daysData: '{{days}}天数据',
    matchScore: '匹配度评分',
    totalFollowers: '总粉丝数',
    avgViewers30: '30日平均观众',
    totalGameTags: '游戏标签总数',

    // 用户信息
    userInfo: '用户信息',
    username: '用户名',
    registrationTime: '注册时间',
    userStatus: '用户状态',
    region: '所在地区',
    lastLogin: '最近登录',
    languagePreference: '语言偏好',
    platformBinding: '平台绑定',
    active: '活跃',
    inactive: '非活跃',
    noInfo: '暂无信息',
    bound: '已绑定 {{count}}/4 个平台',
    excellent: '优秀',
    good: '良好',
    few: '较少',
    unbound: '未绑定',
    noPlatformsBound: '未绑定任何平台',

    // Twitch数据
    twitchData: 'Twitch 数据',
    twitchUsername: 'Twitch 用户名',
    totalFollowers: '总粉丝数',
    accv30: '30日ACCV',
    accv60: '60日ACCV',
    accv90: '90日ACCV',
    fanConversionRate: '粉丝转化率',
    lastUpdated: '最近更新',
    conversionRateDesc: '30日平均观众数 ÷ 总粉丝数',
    noTwitchInfo: '无 Twitch 信息',

    // 游戏标签概览
    gameTagsOverview: '游戏标签概览',
    gameGenres: '游戏类型',
    gameThemes: '游戏主题',
    highestWeightTag: '最高权重标签',
    dataRange: '数据范围',
    avgMatchRate: '平均匹配度',

    // 数据趋势
    accvTimeTrend: 'ACCV 时间趋势',
    accvTrendDesc: '不同时间范围的平均并发观众数对比',
    viewerDataAnalysis: '观众数据分析',
    viewerAnalysisDesc: '粉丝基数与观众活跃度分析',
    currentFollowers: '当前粉丝数',
    avgViewers30Day: '30日观众',
    conversionRate: '转化率',
    dataInterpretation: '数据解读:',
    conversionRateFormula: '• 转化率 = 30日平均观众数 ÷ 总粉丝数 × 100%',
    conversionRateIndicator: '• 转化率越高说明粉丝活跃度越好',
    viewerTrendDesc: '• 观众趋势反映了不同时期的直播表现',
    conversionRateEvaluation: '转化率评估',
    excellentConversion: '✅ 转化率优秀',
    goodConversion: '⚠️ 转化率良好',
    lowConversion: '❌ 转化率较低',

    // 趋势分析
    trendAnalysis: '趋势分析',
    continuousUptrend: '📈 持续上升趋势，表现优异',
    continuousDowntrend: '📉 持续下降趋势，需要关注',
    recentImprovement: '📊 近期表现回升，值得期待',
    recentDecline: '📊 近期表现下滑，建议优化',
    relativelyStable: '📊 表现相对稳定',

    // 主播评价概览
    streamerRatingOverview: '主播评价概览',
    activityRating: '活跃度评价',
    executionRating: '执行力评价',
    costEffectRating: '性价比评价',

    // 游戏标签页面
    tagStatsOverview: '标签统计概览',
    gameGenres: '游戏类型',
    gameThemes: '游戏主题',
    totalWeight: '总权重',
    avgMatchRate: '平均匹配度',
    gameGenreDistribution: '游戏类型分布',
    gameThemeDistribution: '游戏主题分布',
    tags: '标签',
    genreTagDetails: '游戏类型标签详情',
    themeTagDetails: '游戏主题标签详情',
    weight: '权重',
    match: '匹配',
    tagWeightRanking: '标签权重排名',
    top: '前',
    topN: '前{{count}}名',
    noTagData: '暂无标签数据',
    expand: '展开',
    collapse: '收起',

    // 游戏列表
    gameList: '游戏列表',
    games: '个游戏',
    gameName: '游戏名称',
    playTime: '游戏时间',
    releaseTime: '发行时间',
    dataSyncTime: '数据同步时间',
    clickToVisitIGDB: '点击访问 IGDB 游戏页面',
    noGameData: '暂无游戏数据',
    noGameRecords: '该用户在 {{days}} 天内没有游戏记录',

    // 游戏统计
    gameStatsOverview: '游戏统计概览',
    totalGames: '总游戏数',
    totalPlayTime: '总游戏时间',
    avgPlayTime: '平均游戏时间',
    recentNewGames: '近一年新游戏',

    // 历史趋势页面
    historicalTrendAnalysis: '历史趋势分析',
    historicalTrendDesc: '展示用户在不同时间段的ACCV数据对比，帮助了解用户的表现趋势。',
    accvDataOverview: 'ACCV 数据概览',
    dayAverage: '{{days}}天平均',
    audienceFollowerData: '观众粉丝数据',
    dataExplanation: '数据说明',
    accvTimeComparison: 'ACCV 时间段对比',
    dataDetails: '数据详情',
    timeRange: '时间范围',
    relativeChange: '相对变化',
    dataStatus: '数据状态',
    baseline: '基准',
    hasData: '有数据',
    noData: '无数据',
    dataNote: '数据说明',
    dataNote1: '• ACCV (Average Concurrent Viewers): 平均并发观众数，反映主播的直播影响力',
    dataNote2: '• 目前系统记录30天、60天、90天的ACCV数据',
    dataNote3: '• 粉丝转化率 = 30天平均观众数 ÷ 总粉丝数，数值越高说明粉丝活跃度越高',
    dataNote4: '• 相对变化以30天数据为基准，正值表示历史表现更好，负值表示近期表现提升',

    // 时间格式
    minutes: '分钟',
    hours: '小时',
    days: '天',
    unknown: '未知',
    notSynced: '未同步',

    // 数字格式
    thousandAbbrev: '千',
    millionAbbrev: '万',
    billionAbbrev: '亿',

    // 添加缺失的性价比相关翻译
    costEffectivenessEvaluation: '性价比等级评估',
    currentCostEffectivenessLevel: '当前性价比等级',
    costEffectivenessFormula: '性价比计算公式',

    // 性价比等级
    ultraHighCostEffective: '超高性价比',
    highCostEffective: '高性价比',
    mediumCostEffective: '中等性价比',
    normalCostEffective: '普通性价比',
    needsImprovement: '有待提升',

    // 平台数据对比
    platformDataComparison: '平台数据对比',
    recentApplicationCount: '近{{days}}天申请任务数',
    recentCompletionCount: '近{{days}}天完成任务数',
    recentCompletionRate: '近{{days}}天完成率',
    recentAverageReward: '近{{days}}天平均报酬',
    userValue: '用户数值',
    platformAverage: '平台均值',
    vs: '对比',
    abovePlatformAvg: '高于平台均值',
    belowPlatformAvg: '低于平台均值',
    taskCompletionRate: '任务完成率',

    // 主播评价概览  
    streamerRatingOverview: '主播评价概览',
    activityRating: '活跃度评价',
    executionRating: '执行力评价',
    costEffectiveRating: '性价比评价',

    // 数据状态
    dataNotAvailable: '数据不可用',
    noInfo: '暂无信息',

    // 时间相关
    lastUpdated: '最近更新',

    // 添加 stableTrend 翻译
    stableTrend: '📊 趋势稳定，表现一致',

    // 其他缺失的翻译
    risingTrend: '📈 持续上升趋势，表现优异',
    decliningTrend: '📉 持续下降趋势，需要关注',
    recentImprovement: '📊 近期表现回升，值得期待',
    recentDecline: '📊 近期表现下滑，建议优化',
    relativelyStable: '📊 表现相对稳定',

    // 补充缺失的中文翻译
    accvTimeTrendDesc: '不同时间范围的平均并发观众数对比',
    audienceDataAnalysis: '观众数据分析',
    audienceDataAnalysisDesc: '粉丝基数与观众活跃度分析',

    // 性价比评估条件 - 中文
    ultraHighCostEffectiveCondition: '任务平均报酬÷(粉丝数×ACCV) ≤ 平台均值×0.5\n任务完成率 ≥ 70%',
    highCostEffectiveCondition: '任务平均报酬÷(粉丝数×ACCV) ≤ 平台均值\n任务完成率 ≥ 60%',
    mediumCostEffectiveCondition: '任务平均报酬÷(粉丝数×ACCV) ≤ 平台均值×1.5\n任务完成率 ≥ 50%',
    normalCostEffectiveCondition: '任务平均报酬÷(粉丝数×ACCV) ≤ 平台均值×1.5\n任务完成率 25%-50%',
    needsImprovementCondition: '任务平均报酬÷(粉丝数×ACCV) > 平台均值×1.5\n或 任务完成率 < 25%',

    // 粉丝转化率说明 - 中文
    fanConversionRateFormula: '粉丝转化率 = 30天平均观众数 ÷ 粉丝总数 × 100%',
    fanConversionRateDesc: '该指标反映了粉丝的活跃度和忠诚度',

    // 趋势分析 - 中文
    historicalTrend: '历史趋势',
    recentImprovement: '近期表现回升',
    recentDecline: '近期表现下滑',

    // 平台绑定相关 - 中文
    unbound: '未绑定：',
    boundPlatforms: '已绑定平台',

    // 筛选相关 - 中文
    clearAllFilters: '清除所有筛选',

    // 其他缺失的中文翻译
    audienceFollowerData: '观众粉丝数据',
    historicalTrendAnalysis: '历史趋势分析',
    insufficientData: '数据不足',
    insufficientDataDesc: '数据不足，无法进行评估',

    // 主播类型 - 添加未分类
    unclassifiedStreamer: '未分类', // 新增未分类

    missingFollowersOrAccvData: '缺少粉丝数或ACCV数据',
    cannotCalculateCostEffectiveness: '无法计算性价比',
    missingFollowersData: '缺少粉丝数据',
    missingAccvData: '缺少ACCV数据',
    missingBothFollowersAndAccv: '缺少粉丝数和ACCV数据',
    dataRequiredForCalculation: '计算性价比需要粉丝数和ACCV数据',

    // 新增：主播包加载相关翻译
    loadingStreamerPackageData: '正在加载主播包数据...',

    taskInvitationResults: '任务邀约发送结果',
    sendResultsOverview: '发送结果概览',
    successfulSent: '成功发送',
    alreadyJoinedTasks: '已加入任务',
    sendFailed: '发送失败',
    totalProcessed: '总处理数',
    detailedInformation: '详细信息',
    statusExplanation: '状态说明:',
    successfulSentDesc: '邮件已成功发送给用户',
    alreadyJoinedTasksDesc: '用户已经加入了所选的任务，无需重复邀请',
    sendFailedDesc: '由于网络、邮箱等问题导致发送失败',
    skippingUsersOptimization: '对于已加入任务的用户，系统会自动跳过发送，这是正常的优化行为',
    confirm: '确定',

    // 添加 recentDaysData 翻译
    recentDaysData: '近{{days}}天数据',
  },
};

// 改进多语言文本获取函数
export const getMultilingualText = (key, language = 'en', params = {}) => {
  try {
    // 确保语言代码有效 - 只允许英文和中文
    const validLanguages = ['en', 'zh'];
    const targetLanguage = validLanguages.includes(language) ? language : 'en';

    // 获取对应语言的文本
    const texts = MULTILINGUAL_TEXTS[targetLanguage] || MULTILINGUAL_TEXTS.en;
    let text = texts[key];

    // 如果当前语言没有对应文本，回退到英语
    if (!text && targetLanguage !== 'en') {
      text = MULTILINGUAL_TEXTS.en[key];
    }

    // 如果还是没有，返回 key 本身
    if (!text) {
      console.warn(`Missing translation for key: ${key} in language: ${targetLanguage}`);
      return key;
    }

    // 处理参数替换
    if (params && typeof text === 'string') {
      Object.keys(params).forEach(param => {
        const regex = new RegExp(`{{${param}}}`, 'g');
        text = text.replace(regex, params[param]);
      });
    }

    return text;
  } catch (error) {
    console.error(`Error getting text for key ${key}:`, error);
    return key;
  }
};

// 原有的函数保持不变
const languages = lang => (langObj[lang] ? langObj[lang] : lang);

export default languages;